import { Switch, Route } from 'react-router-dom';
import WholesalerCreditReport from './wholesalerCreditReport';
import UploadCredits from './uploadCredits';
import UnmatchedCredits from './unmatchedCredits';
import McKesson from './mckesson/mckesson';
import CustomerListView from './customerListView';
import CreditDetail from './creditReport/creditReport';
import OutboundChecks from './outboundCheck/outboundChecks';
import OutboundCheckOverview from './outboundCheckOverview';
import ReportsRouter from './reports/reportsRouter';
import QuickBooksExport from './QuickbooksExport/quickbooksExport';

const AccountingRouter = () => (
  <Switch>
    <Route exact path="/accounting" component={CustomerListView} />
    <Route
      exact
      path="/accounting/wholesaler/credit/report"
      component={WholesalerCreditReport}
    />
    <Route
      exact
      path="/accounting/wholesaler/credit/report/:id"
      component={UploadCredits}
    />
    <Route
      exact
      path="/accounting/unmatched/credits"
      component={UnmatchedCredits}
    />
    <Route exact path="/accounting/mckesson" component={McKesson} />
    <Route exact path="/accounting/creditdetail" component={CreditDetail} />
    <Route
      exact
      path="/accounting/outbound/checks"
      component={OutboundChecks}
    />
    <Route
      exact
      path="/accounting/outbound/checks/overview"
      component={OutboundCheckOverview}
    />
    <Route exact path="/accounting/qbexport" component={QuickBooksExport} />
    <Route path="/accounting/report" component={ReportsRouter} />
  </Switch>
);

export default AccountingRouter;
